import i18n from 'utils/i18n'

export const createPageTitle = ( name = null ) => {
	const pageTitle = [];
	
	// Add the name
	if( name !== null ) {
		pageTitle.push( name )
	}
	
	// Add the page name
	pageTitle.push( i18n.t('app_name') )
	
	return pageTitle.join(' - ')
}
